"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_table_density_html_1 = __importDefault(require("./widget-table-density.html"));
(function (module) {
    'use strict';
    function WidgetTableDensityController($scope, $filter, $timeout, globalOptions) {
        var $ctrl = this;
        $scope.$ctrl = $ctrl;
        var translate = $filter('translate');
        angular.extend($ctrl, {
            TABLE_DENSITY_OPTIONS: {
                '2px': 'COMPACT',
                '4px': 'COMFORTABLE',
                '8px': 'SPACIOUS'
            },
            $onInit: function () {
                if (!$ctrl.label) {
                    $ctrl.label = translate('TABLE_DENSITY');
                }
            },
            getMenuItems: function () {
                var ret = [];
                if ($ctrl.allowDefault) {
                    ret.push({
                        label: this.getDefaultLabel(),
                        value: null
                    }, {
                        divider: true
                    });
                }
                _.forEach($ctrl.TABLE_DENSITY_OPTIONS, function (value, key) {
                    ret.push({
                        label: translate(value),
                        value: key
                    });
                });
                return ret;
            },
            getDefaultLabel: function () {
                return translate('DEFAULT') + ' (' +
                    translate($ctrl.TABLE_DENSITY_OPTIONS[globalOptions.getTableBodyDensity()]) +
                    ')';
            }
        });
    }
    WidgetTableDensityController.$inject = [
        '$scope',
        '$filter',
        '$timeout',
        'pr.globalOptionsService',
    ];
    module.component('prWidgetTableDensitySelector', {
        templateUrl: widget_table_density_html_1.default,
        controller: WidgetTableDensityController,
        bindings: {
            label: '<',
            allowDefault: '@?',
            tableBodyDensity: '<',
            onChange: '&'
        }
    });
})(angular.module('qualtrics.pr'));
